import React, { useEffect, useContext, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import isEmpty from 'lodash/isEmpty';
import { viewportContext } from '@/context/viewport.context';
import ResourceMap from '@/features/googleMap/components/ResourceMap/ResourceMap';
import { resourceHelpers } from '@/utils/helpers';
import t from '@/utils/Language/ResourceCard-translations';
import { Col, Container, Row } from 'react-bootstrap';
import DistanceTo from '@/components/Resources/DistanceTo/DistanceTo';
import classes from './ResourceCardPanel.module.scss';

const MapPanel = ({ resource, project }) => {
  const primaryLocation = resourceHelpers.primaryLocation(resource);
  const { unusedIsPhone } = useContext(viewportContext);
  var schedule = false;
  const mapRef = useRef(null);

  useEffect(() => {
    //TODO: Need to fix for other projects as well
    if (project === 'allhome') {
      window.scrollTo({ top: mapRef.current.offsetTop - 70, behavior: 'smooth' });
    }
  }, [resource]);

  const isOpportunity = resource.resource_type === 'Opportunity';
  const isOrganization = resource.resource_type === 'Organization';

  const getSchedule = () => {
    const scheduleData = isOrganization ? primaryLocation?.schedule : resource.schedule;
    if (isEmpty(scheduleData)) {
      return false;
    }
    schedule = resourceHelpers.generateSchedule(scheduleData, false, true);
    return schedule;
  };
  const showPanel = (isOpportunity && resource.access_instructions?.length) || isOrganization;

  return (
    <Container fluid className={classes.resourceCardPanel} ref={mapRef}>
      <Row>
        <Col xs="12">
          <h2 className={classes.title}>
            <FontAwesomeIcon icon={[`fas`, `map-marker-alt`]} className={classes.titleIcon} />
            &nbsp; {t('Map')}
          </h2>
        </Col>
      </Row>
      {showPanel && (
        <Row>
          {primaryLocation ? (
            <>
              <Col xs="12" md="6" className="mb-3">
                <ResourceMap
                  options={{
                    center: { lat: primaryLocation.lat, lng: primaryLocation.long },
                    zoom: 14
                  }}
                  locations={[primaryLocation]}
                />
                {unusedIsPhone && (
                  <div className={`mt-3 text-center`}>
                    <a
                      className={classes.buttonLink}
                      href={'https://maps.google.com?daddr=' + resourceHelpers.buildDirectionsUrl(primaryLocation)}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {t('get_directions')}
                    </a>
                  </div>
                )}
              </Col>
              <Col xs="12" md="6">
                <Row className="mb-3">
                  <Col xs="12">
                    <div>
                      <FontAwesomeIcon icon={['fas', 'map-marker-alt']} className={classes.titleIcon} />
                      &nbsp; {t('Address')}
                    </div>
                    {primaryLocation.name && <strong>{primaryLocation.name}</strong>}
                    {resourceHelpers.generateAddressBlock({ location: primaryLocation, layout: 'block' })}
                    {isOrganization && (
                      <div className="mt-2">
                        <DistanceTo locationList={resource.locations} resource={resource} />
                      </div>
                    )}
                    <div className="mt-1">
                      <a
                        className={classes.buttonLink}
                        href={'https://maps.google.com?daddr=' + resourceHelpers.buildDirectionsUrl(primaryLocation)}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {t('get_directions')}
                      </a>
                    </div>
                  </Col>
                </Row>
                {getSchedule() && (
                  <Row>
                    <Col xs="12">
                      <div>
                        <FontAwesomeIcon icon={['fas', 'clock']} className={classes.titleIcon} />
                        &nbsp; {t('Hours')}
                      </div>
                      <div className={classes.schedule}>{schedule}</div>
                    </Col>
                  </Row>
                )}
              </Col>
            </>
          ) : (
            // If an opportunity has no locations, it should always have a region.
            <Col xs="12" className="mb-3">
              {isOpportunity ? (
                <>
                  <h3 className={classes.title}>{t('Locations')}</h3>
                  <p>{t('This opportunity does not have a location or its location is private', { region: resource.region })}</p>
                </>
              ) : (
                <p>{t('This organization does not have a location or its location is private')}</p>
              )}
            </Col>
          )}
        </Row>
      )}
    </Container>
  );
};

export default MapPanel;
